const getPathFromLocation = (location) => location.pathname + location.search;

export default getPathFromLocation;
